import { BookingFormField } from '@domain/booking-form-field';
import { TicketHolderFormField } from '@domain/ticket-holder-form-field';
import { filterCollectedFormFields, isCollectedFormField } from '@utils/collected-form-fields';

const ALLOWED_SLUGS = ['firstName', 'lastName', 'email'] as const;

export const checkBookingFormFieldsAllowed = (fields: BookingFormField[]) => {
  return filterCollectedFormFields(fields).every((field) =>
    ALLOWED_SLUGS.includes(field.slug as (typeof ALLOWED_SLUGS)[number])
  );
};

export const hasTicketHolderFormFields = (fields: TicketHolderFormField[]) => {
  return fields.some(isCollectedFormField);
};
